import React from 'react';
import { IconProps } from '.';

const SvgQuestionMarkBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M13.5 20.5h-3v-3h3v3ZM12.019 3.5c2.687 0 5.188 2.402 5.01 5.34-.07 1.155-.536 2.062-1.06 2.781-.482.66-1.131 1.3-1.522 1.726l-.02.021-.02.022-.022.022c-.024.025-.06.067-.108.122a4.865 4.865 0 0 0-.346.46c-.281.425-.412.787-.412 1.006h-3c0-1.114.53-2.086.91-2.661a7.843 7.843 0 0 1 .815-1.03l.02-.02.008-.007c.542-.59.93-.958 1.274-1.43.309-.422.463-.788.487-1.193.07-1.134-.975-2.159-2.014-2.159C10.985 6.5 10 7.458 10 8.75H7C7 6.042 9.097 3.5 12.019 3.5Z'
      />
    </svg>
  );
};

export default SvgQuestionMarkBold;
